// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"knowledgebase-post-list-module--wrapper--200gc","title":"knowledgebase-post-list-module--title--1GM5L","items":"knowledgebase-post-list-module--items--2_5zk"};